<button
    [class]="getClasses()"
    [style]="getStyle()"
    [disabled]="disabled"
    (click)="onClickHandler()"
    [attr.data-gtm-label]="gtmLabel"
>
    <!-- Icono al inicio -->
    <span *ngIf="shouldShowStartIcon" class="button-icon " [innerHTML]="icon | svgColorInherit"></span>

    <!-- Contenido del botón -->
    <span class="button-content">
        <ng-content></ng-content>
        <app-loading *ngIf="loading"></app-loading>
    </span>

    <!-- Icono al final -->
    <span *ngIf="shouldShowEndIcon" class="button-icon" [innerHTML]="icon | svgColorInherit"></span>
</button>
   